var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.mensagem.id
        ? _c(
            "b-alert",
            {
              attrs: {
                variant: _vm.variantAlert(),
                show: _vm.verifyView(),
                id: _vm.mensagem.tipo
              }
            },
            [
              _c(
                "b-row",
                { attrs: { "align-h": "center" } },
                [
                  _c(
                    "b-col",
                    { staticClass: "col-md-8" },
                    [
                      _c("b-avatar", {
                        staticClass: "mr-2",
                        attrs: { src: _vm.mensagem.user.url }
                      }),
                      _vm._v(" "),
                      _c("strong", [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.mensagem.user.name) +
                            " - "
                        ),
                        _c("span", { staticStyle: { "font-size": "11px" } }, [
                          _vm._v(
                            _vm._s(_vm.getUserHeader(_vm.mensagem.user)) + " "
                          )
                        ])
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "col-md-4" },
                    [
                      _c(
                        "b-row",
                        { attrs: { "align-h": "center", id: "created_at" } },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.formatarData(_vm.mensagem.created_at)
                              ) +
                              "\n        "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { attrs: { "align-h": "center" } },
                        [
                          _c(
                            "b-badge",
                            {
                              attrs: {
                                variant:
                                  _vm.getStatus == "CANCELAR"
                                    ? "danger"
                                    : "secondary"
                              }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.getStatus) +
                                  "\n          "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.mensagem.tipo == "SOLUCIONAR" &&
              _vm.tipoReembolso &&
              _vm.tipoReembolso !== "null"
                ? _c(
                    "b-row",
                    { staticClass: "mt-3" },
                    [
                      _c(
                        "b-col",
                        { staticClass: "text-right" },
                        [
                          _c("b-badge", { attrs: { variant: "success" } }, [
                            _vm._v(
                              "\n          Tipo de Reembolso: " +
                                _vm._s(_vm.getTipoReembolso) +
                                "\n        "
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.mensagem.produtos.length > 0
                ? _c(
                    "b-row",
                    { staticClass: "mt-3" },
                    [
                      _c(
                        "b-col",
                        [
                          _c("b-table", {
                            attrs: {
                              borderless: "",
                              "no-border-collapse": "",
                              small: "",
                              items: _vm.mensagem.produtos,
                              fields: _vm.colunasTabela
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mt-3 mb-3" },
                [
                  _c("b-col", { staticClass: "ml-3" }, [
                    _c("pre", [
                      _vm._v(
                        "            " +
                          _vm._s(_vm.mensagem.mensagem) +
                          "\n        "
                      )
                    ])
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _vm.mensagem.arquivos.length > 0
                ? _c(
                    "b-row",
                    { staticClass: "mt-3", attrs: { "align-v": "center" } },
                    [
                      _c("b-col", { staticClass: "col-md-2 text-right" }, [
                        _c("b", [_vm._v(" Anexos: ")])
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.arquivos, function(arquivo, id) {
                        return _c(
                          "div",
                          { key: id },
                          [
                            arquivo.path && arquivo.tipo[1] == "pdf"
                              ? _c("b-col", { staticClass: "text-left" }, [
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: arquivo.url,
                                        target: "_blank"
                                      }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fas fa-file-pdf fa-2x"
                                      })
                                    ]
                                  )
                                ])
                              : _c(
                                  "b-col",
                                  {
                                    staticClass: "text-left",
                                    attrs: { id: id }
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        attrs: { href: "#" },
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            return _vm.verAnexo(arquivo)
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "b-img",
                                          _vm._b(
                                            {
                                              attrs: {
                                                thumbnail: "",
                                                fluid: "",
                                                src: arquivo.url,
                                                rounded: "",
                                                alt: "Rounded image"
                                              }
                                            },
                                            "b-img",
                                            _vm.mainProps,
                                            false
                                          )
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                )
                          ],
                          1
                        )
                      })
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-row",
                { attrs: { "align-h": "center" } },
                [
                  _c("b-col"),
                  _vm._v(" "),
                  _vm.mensagem.reembolso
                    ? _c(
                        "b-col",
                        { staticClass: "col-md-4" },
                        [
                          _c(
                            "b-row",
                            { attrs: { "align-h": "center" } },
                            [
                              _c(
                                "b-badge",
                                {
                                  attrs: {
                                    variant:
                                      _vm.mensagem.reembolso == "APROVADO"
                                        ? "success"
                                        : "danger"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n            REEMBOLSO " +
                                      _vm._s(_vm.mensagem.reembolso) +
                                      "\n          "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            centered: "",
            "ok-title": "Fechar",
            "ok-only": "",
            "hide-header": "",
            size: "xl"
          },
          model: {
            value: _vm.modalAnexo,
            callback: function($$v) {
              _vm.modalAnexo = $$v
            },
            expression: "modalAnexo"
          }
        },
        [
          _c(
            "b-row",
            { attrs: { "align-h": "center", "align-v": "center" } },
            [
              _c("b-img", {
                attrs: {
                  width: "650",
                  height: "750",
                  src: _vm.arquivoModal.url,
                  fluid: ""
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-05e8e9f1", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05e8e9f1","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/ocorrencia/componente/Mensagem.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-05e8e9f1","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/ocorrencia/componente/Mensagem.vue
// module chunks = 2